module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie ValuedTextInput is a text input with label and value inset into the input.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;ValuedTextInput label       = &quot;How much?&quot;\n                 value       = &quot;Euro&quot;\n                 placeholder = &quot;52.5&quot;/&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/ValuedTextInput/README.md
// module id = 411
// module chunks = 0